import { render, staticRenderFns } from "./WordcloudCard.vue?vue&type=template&id=24612ea7&"
import script from "./WordcloudCard.vue?vue&type=script&lang=js&"
export * from "./WordcloudCard.vue?vue&type=script&lang=js&"
import style0 from "./WordcloudCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports